import { FC, useMemo } from 'react';
import type { TObjectDeleteJob } from 'types/objectJob.type';
import { Typography } from '@timeedit/ui-components';
import { Button, Modal, Table } from '@timeedit/ui-components/antd';
import type { ColumnsType } from '@timeedit/ui-components/antd/table/index';
import './JobObjectsModal.scss';

const { Text } = Typography;

type Row = { id: number; extId: string };

type Props = {
  open: boolean;
  onClose: () => void;
  job: TObjectDeleteJob;
};

const DeleteJobObjectsModal: FC<Props> = (props) => {
  const columns = useMemo<ColumnsType<Row>>(
    () => [
      { title: 'ID', dataIndex: 'id', key: 'id', width: 200 },
      { title: 'External ID', dataIndex: 'extId', key: 'extId' },
    ],
    []
  );

  return (
    <Modal
      destroyOnHidden
      onOk={props.onClose}
      onCancel={props.onClose}
      closable={false}
      open={props.open}
      width={'75vw'}
      footer={[
        <Button type="primary" size="middle" key="ok" onClick={props.onClose}>
          Ok
        </Button>,
      ]}
    >
      <div className="job-objects-modal__title">
        <Text>
          <Text strong>Object type:</Text> {props.job.objectTypeName}{' '}
          <Text strong>Objects:</Text> {props.job.objectsToProcess.length}
        </Text>
      </div>
      <Table<Row>
        columns={columns}
        dataSource={props.job.objectsToProcess}
        rowKey="id"
        pagination={false}
        size="small"
        scroll={{ y: 500 }}
      />
    </Modal>
  );
};

export default DeleteJobObjectsModal;
